import { Component, HostListener } from '@angular/core';
import { AddStateService } from './add-state-service/add-state.service';
import { CountryService } from './country-service/country.service';
import { ResignationService } from './resig-service/resignation.service';
import { MaintenanceService } from './maint-service/maintenance.service';
import { ProviderTypeService } from './prov-service/provider-type.service';
import { RequestTypeService } from './req-type/request-type.service';

export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent {
  title = 'Provider Intake Form';

  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    if (window.navigator.msSaveOrOpenBlob) {
      event.returnValue = 'Changes you made may not be saved' as any; // because internet explorer is weird
    }
    else {
      event.returnValue = false;
    }
  }

  constructor(
    private stateService: AddStateService,
    private countryService: CountryService,
    private resignService: ResignationService,
    private maintenanceService: MaintenanceService,
    private providerService: ProviderTypeService,
    private reqTypeService: RequestTypeService) {
      this.stateService.setupStateServiceCall();
      this.countryService.getCountries();
      this.resignService.getReasons();
      this.maintenanceService.getMaintenance();
      this.providerService.getProvider();
      this.reqTypeService.getReqTypes();
  }
}
